import Login from "src/Login/Login";

export const authRoutes = {
  path: "login",
  element:<Login/>
};
